import { combineReducers } from 'redux';
import provinceReducer from './provinceReducer';
import amphureReducer from './amphureReducer';
import authReducer from './authReducer';
import profileReducer from './profileReducer';
import wishlistReducer from './wishlistReducer';
import unitReducer from './unitReducer';
import viewReducer from './viewReducer';
import favReducer from './favReducer';
import nameReducer from './nameReducer';

const allReducers = combineReducers({
    wishlist: wishlistReducer,
    province: provinceReducer,
    amphure: amphureReducer,
    auth: authReducer,
    profile: profileReducer,
    unit: unitReducer,
    view: viewReducer,
    fav: favReducer,
    userInfo: nameReducer,
})

export default allReducers;